import React, { useState } from "react";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { formatApiError } from "@/lib/api";

export default function Register() {
  const { user, register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(email, password, name);
      toast.success("Account created");
      navigate("/");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-8 bg-background">
      <form onSubmit={submit} className="w-full max-w-sm space-y-6" data-testid="register-form">
        <div>
          <div className="overline text-muted-foreground">Create account</div>
          <h1 className="font-display text-3xl font-bold tracking-tight mt-1">Get started</h1>
          <p className="text-xs text-muted-foreground mt-2">Client accounts require an admin to grant workspace access.</p>
        </div>
        <div className="space-y-4">
          <div>
            <Label className="overline">Name</Label>
            <Input data-testid="reg-name" value={name} onChange={(e) => setName(e.target.value)} required className="rounded-none mt-2 h-11" />
          </div>
          <div>
            <Label className="overline">Email</Label>
            <Input data-testid="reg-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="rounded-none mt-2 h-11" />
          </div>
          <div>
            <Label className="overline">Password</Label>
            <Input data-testid="reg-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} className="rounded-none mt-2 h-11" />
          </div>
        </div>
        <Button data-testid="reg-submit" type="submit" disabled={loading} className="w-full h-11 rounded-none">
          {loading ? "Creating…" : "Create account"}
        </Button>
        <div className="text-xs text-muted-foreground">
          Already have an account? <Link to="/login" className="underline underline-offset-2 text-foreground" data-testid="link-login">Sign in</Link>
        </div>
      </form>
    </div>
  );
}
